import { __assign } from "tslib";
import { useUpdateUserStorage } from '@office-start/user-storage-service';
import { useUserProfileMetricsKey } from './useUserProfileMetricsKey';
var mergeUpdatePreviousUserProfile = function (previousUserProfile, eventMetrics) {
    var now = Date.now();
    if (!previousUserProfile) {
        return {
            created: now,
            metrics: eventMetrics,
            saved: now,
        };
    }
    return __assign(__assign({}, previousUserProfile), { saved: now, metrics: __assign(__assign({}, previousUserProfile.metrics), eventMetrics) });
};
export var useUpdateUserProfileMetrics = function () {
    var userProfileMetricsKey = useUserProfileMetricsKey();
    return useUpdateUserStorage(userProfileMetricsKey, mergeUpdatePreviousUserProfile);
};
//# sourceMappingURL=useUpdateUserProfile.js.map